export default __webpack_public_path__ + "static/media/1-min.45d8794a.jpg";